import {Route} from 'vue-router';
import RatingTableView from '@/views/rating/RatingTableView.vue';
import UserRatingView from '@/views/rating/UserRatingView.vue';
import UnconfirmedReportsView from '@/views/rating/UnconfirmedReportsView.vue';

export const routes = [
  {
    name: 'home', path: '/:lang', component: RatingTableView, props: (r: Route) => ({
      lang: r.params.lang,
      allPlayersMode: false,
    }),
  },
  {
    name: 'rating_all', path: '/:lang/all', component: RatingTableView, props: (r: Route) => ({
      lang: r.params.lang,
      allPlayersMode: true,
    }),
  },
  {
    name: 'my_rating', path: '/:lang/user/me', component: UserRatingView, props: (r: Route) => ({
      lang: r.params.lang,
      userId: r.params.userId,
    }),
  },
  {
    name: 'user_rating', path: '/:lang/user/:userId', component: UserRatingView, props: (r: Route) => ({
      lang: r.params.lang,
      userId: r.params.userId,
    }),
  },
  {
    name: 'unconfirmed_violators',
    path: '/:lang/unconfirmed/violators',
    component: UnconfirmedReportsView,
    props: (r: Route) => ({
      lang: r.params.lang,
      showViolators: true,
    }),
  },
  {
    name: 'unconfirmed_by_me', path: '/:lang/unconfirmed/me', component: UnconfirmedReportsView, props: (r: Route) => ({
      lang: r.params.lang,
      showViolators: false,
      username: r.params.username,
      reports: null,
    }),
  },
  {
    name: 'unconfirmed', path: '/:lang/unconfirmed/all', component: UnconfirmedReportsView, props: (r: Route) => ({
      lang: r.params.lang,
      showViolators: false,
      username: null,
      reports: null,
    }),
  },
  {
    name: 'unconfirmed_by_user',
    path: '/:lang/unconfirmed/:username',
    component: UnconfirmedReportsView,
    props: (r: Route) => ({
      lang: r.params.lang,
      showViolators: false,
      username: r.params.username,
      reports: null,
    }),
  },
  {path: '*', redirect: '/ru'},
];
